import { compose, forEach, map, prop, values } from "ramda"
import { all } from "redux-saga/effects"
import { useEffect } from "react"

import * as List from "../list/index.js"

export const from = function* (...effectLists) {
  for (const list of effectLists) {
    yield all(list)
  }
}

/**
 * Takes effect lists from the given slices and concatenates them.
 * Each list should be indexed by "effects" key inside its own slice.
 *
 * @param {object|Record} slices object or record with slices indexed by key
 */
export const list = compose(List.merged, map(prop("effects")), values)

export const registered = function* (...slices) {
  for (const slice of slices) {
    yield all(slice.effects)
  }
}

/**
 * Subscribes to each of given Flux stores with a callback
 *
 * @param {function} coeffect
 * Callback that will be called once on component mount
 * and then will be called on each update of any store from the list
 *
 * @param {function} stores List of Flux stores
 * @returns {void}
 */
export const useFlux = (coeffect, stores) =>
  useEffect(() => {
    coeffect()

    const subscriptions = map((store) => store.addListener(coeffect), stores)

    return () => forEach((subscription) => subscription.remove(), subscriptions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
